import React from 'react'
import { Modal, Select, Input } from 'antd'
import './styles.scss'

export default ({ visible, name, category='Others', categories=[],
                    on_change, on_hide, on_save, on_search, on_focus }) => {
    return (
        <Modal visible={visible} className='finance-add-product'
               footer={null} width={467} onCancel={()=> on_hide('add_product')}>
            <header>Add Custom Service</header>
            <section>
                <header>Manually add any additional product or service to your planned budget</header>

                <div className={'input-group'}>
                    <label>Name</label>
                    <Input value    = {name}
                           name     = 'product_name'
                           size     = 'large'
                           onChange = {on_change}/>
                </div>

                <div className={'input-group'}>
                    <label>Category</label>
                    <Select
                        value           = {category}
                        size            = 'large'
                        name            = 'product_category'
                        onChange        = {e=>on_change({name:'product_category', value:e})}
                        notFoundContent = {'Others'}
                        style           = {{width:'100%'}}
                        showArrow       = {false}
                        onSearch        = {on_search}
                        onFocus         = {on_focus}
                        showSearch>
                        {categories.map(e => <Select.Option key={e}>{e}</Select.Option>)}
                    </Select>
                </div>
            </section>
            <footer>
                <button onClick={()=>on_save()}>Save</button>
            </footer>
        </Modal>
    )
}